// Exports a discrete Naive UI API that works outside of setup() context.
// Import `message` in any module to call message.success(...), etc.

import { createDiscreteApi } from 'naive-ui'

const { message, notification, dialog } = createDiscreteApi(['message', 'notification', 'dialog'])

export { message, notification, dialog }
